<script>
import { mapGetters, mapActions } from "vuex";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";

/**
 * Login-2 component
 */
export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
      forgotPassword: false,
      secondStep: false,
      lastStep: false,
      thirdStep: false,
      token: "",
      resetPassword: {
        password: "",
        confirmPassword: ""
      },
      pageError: {
        confirmPasswordError: false,
      }
    };
  },
  validations: {
    username: {
      required,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapGetters("auth", [
      "loggedIn",
      "getLogging",
      "getAuthError",
      "getLoggingMessage",
      "getCurrentUser",
      "getResetStatus",
      "getResetMessage",
      "getUserResetDetails",
      "getSentToken",
      "getTokenValidation",
      "getResetProcess",
    ]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  watch: {
    getUserResetDetails() {
      if (this.getUserResetDetails) {
        this.secondStep = true
      }
    },
    getSentToken(){
      if(this.getSentToken){
      this.thirdStep = true
      }
    },
    getTokenValidation(){
      if(this.getTokenValidation) {
        this.lastStep = true;
      }
    }
  },
  methods: {
    ...mapActions({
      logIn: "auth/logIn",
      ValidateUsername: "auth/validateUsername",
      SubmitToken: "auth/submitToken",
      ValidateSubmitedToken: "auth/validateSubmitedToken",
      SubmitPasswordReset: "auth/submitPasswordReset"
    }),
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        return this.logIn({
          username: this.username,
          password: this.password,
        });
      }
    },

    toggoForgot() {
      this.forgotPassword = !this.forgotPassword
    },
    toggoSignin(){
      this.forgotPassword = false;
      this.secondStep = false;
      this.lastStep = false;
      this.thirdStep = false;
    },
    //sending username validation request
    validateUsername(){
      this.ValidateUsername({username: this.username})
    },
    // usernameValidationForm(){},
    validateToken(){
      this.ValidateSubmitedToken({
        token: this.token,
        id: this.getUserResetDetails.id
      });
    },
    sendToken(){
      this.SubmitToken({
        contact: this.getUserResetDetails.phone,
        email: this.getUserResetDetails.email,
        id: this.getUserResetDetails.id,
      });
    },

    //validating confirm password
    checkPassword(){
      if(this.resetPassword.confirmPassword != ""){
        var regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/
        var isValid = this.resetPassword.confirmPassword.match(regex);
        if(this.resetPassword.password === this.resetPassword.confirmPassword) {
          if (isValid) {
            this.pageError.confirmPasswordError = "";
          }else{
            this.pageError.confirmPasswordError = "Atleast one special-character, lowecase, uppercase and minimum of 8 characters";
          }
        }else{
          this.pageError.confirmPasswordError = "Password Don't Match";
        }
      }
    },
    submitResetPassword(){
      if(this.pageError.confirmPasswordError == ""){
        this.SubmitPasswordReset({
          password: this.resetPassword.password,
          confirmPassword: this.resetPassword.confirmPassword,
          id: this.getUserResetDetails.id,
        });
      }
    }
    
  },
  mounted() {
    document.body.classList.add("auth-body-bg");
  },
};
</script>

<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row g-0">
        <div class="col-xl-9">
          <div class="auth-full-bg pt-lg-2 p-2">
            <div class="w-100">
              <div class="bg-overlay"></div>
              <div class="d-flex h-100 flex-column">
                <div class="p-2 mt-auto mb-auto">
                  <div class="row justify-content-center">
                    <div class="col-lg-7">
                      <div class="text-center">
                        <h4 class="mb-3">
                          <i
                            class="
                              bx
                              bxs-quote-alt-left
                              text-primary
                              h1
                              align-middle
                              mr-3
                            "
                          ></i
                          ><span class="text-primary">Academic</span> Master
                        </h4>

                        <div dir="ltr" class="owl-theme">
                          <b-carousel
                            id="carousel-1"
                            :interval="4000"
                            indicators
                          >
                            <b-carousel-slide>
                              <p class="font-size-16 mb-4">
                                Manage your School with the best software. Helps
                                in creating student's Reports, Printing Reports,
                                Student's Data Managment. Those are the few
                                functionalities of the system academicaly
                              </p>
                              <!-- <div>
                                <h4 class="font-size-16 text-primary">
                                  Abs1981
                                </h4>
                                <p class="font-size-14 mb-0">- Skote User</p>
                              </div> -->
                            </b-carousel-slide>

                            <b-carousel-slide>
                              <p class="font-size-16 mb-4">
                                Manage Your finances in the School by using
                                Academic Master. Create your budget for the
                                academic year, Track your expenses in the school,
                                Manage student's fees payments, Make fees
                                exemptions e.t.c
                              </p>
                              <!-- <div>
                                <h4 class="font-size-16 text-primary">
                                  nezerious
                                </h4>
                                <p class="font-size-14 mb-0">- Skote User</p>
                              </div> -->
                            </b-carousel-slide>
                          </b-carousel>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end col -->

        <div class="col-xl-3">
          <div class="auth-full-page-content p-md-5 p-4">
            <div class="w-100">
              <div class="d-flex flex-column h-100">
                <div class="mb-2 mb-md-2">
                  <center><router-link to="/" class="d-block auth-logo">
                    <img
                      src="@/assets/images/am.png"
                      alt=""
                      height="100"
                      class="auth-logo-dark"
                    />
                    <img
                      src="@/assets/images/am.png"
                      alt=""
                      height="100"
                      class="auth-logo-light"
                    />
                  </router-link></center>
                </div>
                <div class="my-auto">
                  <div>
                    <h5 class="text-primary">Welcome Back !</h5>
                    <p class="text-muted">Sign in to continue to Academic Master.</p>
                  </div>
                  <div
                    v-if="getLoggingMessage.includes('Error')"
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                  >
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <strong class="font-sm">{{ getLoggingMessage }}</strong>
                  </div>
                  <div
                    v-else-if="getLoggingMessage.includes('Successfull')"
                    class="alert alert-success alert-dismissible fade show"
                    role="alert"
                  >
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <strong class="font-sm">Login Successful, Redirecting...</strong>
                  </div>

                  <div
                    v-if="notification.message"
                    :class="'alert ' + notification.type"
                  >
                    {{ notification.message }}
                  </div>

                  <!-- login form  -->
                  <div class="mt-4" v-if="!forgotPassword && !secondStep && !thirdStep && !lastStep">
                    <form @submit.prevent="tryToLogIn()">
                      <b-form-group
                        class="mb-3"
                        id="input-group-1"
                        label="User Name"
                        label-for="input-1"
                      >
                        <b-form-input
                          id="input-1"
                          v-model="username"
                          type="text"
                          required
                          placeholder="Enter User Name"
                          :class="notification.message ? 'is-invalid' : ''"
                        ></b-form-input>
                        <div
                          v-if="submitted && $v.username.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.username.required">
                            User Name is required.
                          </span>
                        </div>
                      </b-form-group>
                      <b-form-group
                        class="mb-3"
                        id="input-group-2"
                        label="Password"
                        label-for="input-2"
                      >
                        <b-form-input
                          id="input-2"
                          v-model="password"
                          type="password"
                          @keyup="checkPassword"
                          required
                          placeholder="Enter password"
                          :class="getLoggingMessage.includes('Error') ? 'is-invalid' : ''"
                        ></b-form-input>
                        <div
                          v-if="submitted && !$v.password.required"
                          class="invalid-feedback"
                        >
                          Password is required.
                        </div>
                      </b-form-group>
                      <div class="mt-3 d-grid">
                        <b-button
                          v-if="getLogging"
                          type="submit"
                          variant="primary"
                          disabled
                        >
                          <b-spinner
                            variant="light"
                            small
                            label="Saving"
                          ></b-spinner>
                          Logging in
                        </b-button>
                        <b-button v-else type="submit" variant="primary"
                          >Log In</b-button
                        >
                      </div>
                    </form>
                    <div class="col-md-12 mt-3">
                      <a href="#" @click.prevent="toggoForgot()" class="mt-2 float-end"><u>Forgot Password</u></a>
                    </div>
                  </div>

                  <!-- forgot password validate username functionality -->
                  <div class="mt-4" v-else-if="forgotPassword && !secondStep && !thirdStep && !lastStep">
                    <div class="alert alert-primary" role="alert">
                      <strong>Recover Password</strong> <br/>
                      <span>STEP 1 / 4</span>
                    </div>
                    <form @submit.prevent="validateUsername()">
                      <b-form-group
                        class="mb-3"
                        id="input-group-3"
                        label="Enter User Name/Email/Contact"
                        label-for="input-1"
                      >
                        <b-form-input
                          id="input-1"
                          v-model="username"
                          required
                          type="text"
                          placeholder="User Name or Email or Contact"
                          :class="getResetMessage && getResetMessage.includes('User Details') ? 'is-invalid' : ''"
                        ></b-form-input>
                        <div
                          v-if="submitted && $v.username.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.username.required">
                            User Name is required.
                          </span>
                        </div>
                      </b-form-group>
                      <div class="mt-3 d-grid">
                        <div class="text-danger" v-if="getResetMessage && getResetMessage.includes('User Details')" role="alert">
                          User Details Not Found
                        </div>
                      </div>
                      <div class="mt-3 d-grid">
                        <b-button
                          v-if="getResetStatus"
                          variant="primary"
                          disabled
                        >
                          <b-spinner
                            variant="light"
                            small
                            label="Saving"
                          ></b-spinner>
                          Validating...
                        </b-button>
                        <b-button v-else type="submit" variant="primary"
                          ><i class="fa fa-check" aria-hidden="true"></i> Submit</b-button
                        >
                      </div>
                    </form>
                    <div class="col-md-12 mt-3">
                      <a href="#" @click.prevent="toggoSignin()" class="mt-2 float-end"><u>Sign in</u></a>
                    </div>
                  </div>

                  <!-- forgot password send token functionality -->
                  <div class="mt-4" v-else-if="forgotPassword && secondStep && !thirdStep && !lastStep">
                    <div class="alert alert-primary" role="alert">
                      <strong>Recover Password</strong> <br/>
                      <span>STEP 2 / 4</span>
                    </div>
                    <div class="col-md-12">
                      <h6>Dear, <b>{{ getUserResetDetails.name }}</b></h6>
                      <br/>
                      <p class="text-muted"><strong class="mb-3">A token will be sent on:</strong></p>
                      <p><b class="text-muted">Contact:</b> {{getUserResetDetails.phone.slice(0, 2)}}******{{ getUserResetDetails.phone.slice(-3) }}</p>
                      <!-- <p><b class="text-muted">Email:</b> {{getUserResetDetails.email.split("@")[0].slice(0, 2)}}*********@{{ getUserResetDetails.email.split("@")[1]}}</p> -->
                    </div>
                      <div class="mt-3 d-grid">
                        <b-button
                          v-if="getResetStatus"
                          type="submit"
                          variant="primary"
                          disabled
                        >
                          <b-spinner
                            variant="light"
                            small
                            label="Saving"
                          ></b-spinner>
                          Sending Token...
                        </b-button>
                        <b-button v-else type="submit" variant="primary" @click="sendToken()">
                          <i class="fa fa-check" aria-hidden="true"></i> Send Token
                        </b-button>
                      </div>
                    <div class="col-md-12 mt-3">
                      <a href="#" @click.prevent="toggoSignin()" class="mt-2 float-end"><u>Sign in</u></a>
                    </div>
                  </div>

                  <!-- forgot password validate token functionality -->
                  <div class="mt-4" v-else-if="forgotPassword && secondStep && thirdStep && !lastStep">
                    <div class="alert alert-primary" role="alert">
                      <strong>Recover Password</strong> <br/>
                      <span>STEP 3 / 4</span>
                    </div>
                    <div class="col-md-12">
                    </div>
                    <form @submit.prevent="validateToken()">
                      <b-form-group
                        class="mb-3"
                        id="input-group-4"
                        label="Enter Token"
                        label-for="input-1"
                      >
                        <b-form-input
                          id="input-4"
                          v-model="token"
                          required
                          type="text"
                          placeholder="Enter Token"
                          :class="getResetMessage && getResetMessage.includes('Invalid Token') ? 'is-invalid' : ''"
                        ></b-form-input>
                        <div
                          v-if="submitted && $v.username.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.username.required">
                            Token is required.
                          </span>
                        </div>
                        <div class="text-danger mt-2" v-if="getResetMessage && getResetMessage.includes('Invalid Token')" role="alert">
                          Invalid Token
                        </div>
                      </b-form-group>
                      <div class="mt-3 d-grid">
                        <b-button
                          v-if="getResetStatus"
                          variant="secondary"
                          disabled
                        >
                          <b-spinner
                            variant="light"
                            small
                            label="Saving"
                          ></b-spinner>
                          Validating Token...
                        </b-button>
                        <b-button v-else type="submit" variant="secondary"
                          ><i class="fa fa-check" aria-hidden="true"></i> Submit Token</b-button
                        >
                      </div>
                    </form>
                    <div class="col-md-12 mt-3">
                      <a href="#" @click.prevent="toggoSignin()" class="mt-2 float-end"><u>Sign in</u></a>
                    </div>
                  </div>


                  <!-- forgot password functionality -->
                  <div class="mt-4" v-else-if="forgotPassword && secondStep && thirdStep && lastStep">
                    <div class="alert alert-primary" role="alert">
                      <strong>Recover Password</strong> <br/>
                      <span>STEP 4 / 4</span>
                    </div>
                    <form @submit.prevent="submitResetPassword()" v-if="getResetProcess == false">
                      <b-form-group
                        class="mb-3"
                        id="input-group-4"
                        label="Enter New password"
                        label-for="input-4"
                      >
                        <b-form-input
                          id="input-4"
                          v-model="resetPassword.password"
                          type="password"
                          @keyup="checkPassword"
                          required
                          placeholder="Enter New password"
                          :class="notification.message ? 'is-invalid' : ''"
                        ></b-form-input>
                        <div
                          v-if="submitted && !$v.password.required"
                          class="invalid-feedback"
                        >
                          Password is required.
                        </div>
                      </b-form-group>

                      <b-form-group
                        class="mb-3"
                        id="input-group-5"
                        label="Confirm Password"
                        label-for="input-2"
                      >
                        <b-form-input
                          id="input-5"
                          v-model="resetPassword.confirmPassword"
                          type="password"
                          required
                          @keyup="checkPassword"
                          placeholder="Confirm password"
                          :class="pageError.confirmPasswordError != '' ? 'is-invalid' : ''"
                        ></b-form-input>
                        <div
                          v-if="submitted && !$v.password.required"
                          class="invalid-feedback"
                        >
                          Password is required.
                        </div>
                        <span v-if="pageError.confirmPasswordError != ''" class="text-danger">{{pageError.confirmPasswordError}}</span>
                      </b-form-group>

                      <div class="mt-3 d-grid">
                        <b-button
                          v-if="getResetStatus"
                          type="submit"
                          variant="success"
                          disabled
                        >
                          <b-spinner
                            variant="light"
                            small
                            label="Saving"
                          ></b-spinner>
                          Resetting...
                        </b-button>
                        <b-button v-else type="submit" variant="success"
                          >Reset Password</b-button
                        >
                      </div>
                    </form>
                    <div class="col-md-12" v-else>
                      <div class="alert alert-success" role="alert">
                        <strong>Password Reset Successfully</strong>
                      </div>
                      <a class="btn btn-sm btn-primary" href="/" role="button">Sign in</a>
                    </div>
                    <div class="col-md-12 mt-3" v-if="getResetProcess == false">
                      <a href="#" @click.prevent="toggoSignin()" class="mt-2 float-end"><u>Sign in</u></a>
                    </div>
                  </div>
                </div>

                <div class="mt-4 mt-md-5 text-center">
                  <p class="mb-0">
                    {{ new Date().getFullYear() - 1 }} -
                    {{ new Date().getFullYear() }} © Academic Master | All Rights Reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container-fluid -->
  </div>
</template>

<style lang="scss" scoped>
::v-deep .carousel-caption {
  position: relative !important;
  right: 0;
  bottom: 1.25rem;
  left: 0;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #495057;
  text-align: center;
}

::v-deep .carousel-indicators li {
  background-color: rgba(85, 110, 230, 0.25);
}
</style>